/**
 * This is a simple way to pass messages between application components.
 */
var eventify = require('ngraph.events');

module.exports = eventify({});